import React from 'react';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';
import {
  SHARED_DYN_WRAPPER_CONSTRAINTS_ANCESTORS,
  SHARED_DYN_WRAPPER_CONSTRAINTS_DESCENDANTS,
} from '@packages/systems/core/constants/SharedConstraintRules';
import {CLASS_NAME_LOCALES_WRAPPER} from '../constants';

const LocalesWrapper = Atom.createRender(
  ({attributes, classes, generateAttributes, context, data, renderChild}) => {
    const wrapperClasses = classes.push(CLASS_NAME_LOCALES_WRAPPER);
    const props = generateAttributes(attributes, wrapperClasses);
    const children = getChildren(data);

    return (
      <div {...props}>
        {children.map((child) => renderChild(child, context))}
      </div>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Locales Wrapper',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Localization'), iconName('LocalesList')),
  },
  render: LocalesWrapper,
  showEmpty: false,
  constraints: {
    ancestors: SHARED_DYN_WRAPPER_CONSTRAINTS_ANCESTORS,
    descendants: SHARED_DYN_WRAPPER_CONSTRAINTS_DESCENDANTS,
  },
  fields: {
    children: TListOfElement,
  },
});

export default config;
